// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xikJagh8bQmw5sl0eZJZ{min-height:100px;position:relative}`, "",{"version":3,"sources":["webpack://./components/DefectValidator/data/defectNotifyStatus/DefectNotifyStatus.module.scss"],"names":[],"mappings":"AAAA,sBACC,gBAAA,CACA,iBAAA","sourcesContent":[".defectNotifyStatus {\r\n\tmin-height: 100px;\r\n\tposition: relative;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defectNotifyStatus": `xikJagh8bQmw5sl0eZJZ`
};
export default ___CSS_LOADER_EXPORT___;
